import { ColumnDefinition } from '@scope/scope-one-ui/core/DataTable/DataTable.d';
import { SIZES } from '@scope/scope-one-ui/theme';
import { groupComparisonRenderer, rangeRenderer, scoreRenderer } from '../../utils/renderers';

export const compareTableCols: ColumnDefinition[] = [
  {
    name: 'comparison',
    label: 'Comparison',
    customBodyRender: groupComparisonRenderer,
  },
  {
    name: 'scoreOne',
    label: '30D',
    align: 'center',
    size: SIZES.spacing(15),
    customBodyRender: scoreRenderer('numeric'),
  },
  {
    name: 'scoreTwo',
    label: 'Today',
    align: 'center',
    size: SIZES.spacing(15),
    customBodyRender: scoreRenderer('numeric'),
  },
  {
    name: 'rangeScore',
    label: 'Today vs 1Y Range',
    align: 'center',
    size: SIZES.spacing(22),
    customBodyRender: rangeRenderer,
  },
];

export const topCompaniesTableCols: ColumnDefinition[] = [
  {
    name: 'companyName',
    label: 'Company Name',
  },
  {
    name: 'scoreOne',
    label: '30D',
    align: 'center',
    size: SIZES.spacing(15),
    customBodyRender: scoreRenderer('numeric'),
  },
  {
    name: 'scoreTwo',
    label: 'Today',
    align: 'center',
    size: SIZES.spacing(15),
    customBodyRender: scoreRenderer('numeric'),
  },
  {
    name: 'rangeScore',
    label: 'Today vs 1Y Range',
    align: 'center',
    size: SIZES.spacing(22),
    customBodyRender: rangeRenderer,
  },
];
